export default "__VITE_ASSET__Bte5oWzb__"